import { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import TimetableRBC from './TimeTableRBC.js';
import { TimeTableFilter } from './TimeTableFilter.js';

export default function CalendarForm(props) {
  const [filters, setFilters] = useState({ onlyActive: true, teacherId: -1 });
  const handleChange = useCallback((f) => setFilters(f), []);

  return (
    <Box sx={{ p: 2 }}>
      <TimeTableFilter
        defaultOnlyActive={true}
        defaultTeacherId={-1}
        onChange={handleChange}
      />
      <TimetableRBC filters={filters} />
    </Box>
  );
}
